require([
	'jquery',
	'root/Base/Js/MbiImageSize',
	'root/Base/Js/MbiMediaQuery',
    'Voucher',
	'Flickity',
	'SmoothScroll',
	'wow',
	'waypoints',
	'root/Assets/Js/Vendor/countUp',
	'root/Base/Js/MbiBrowser',
	'root/Base/Js/Vendor/PictureFill',
	'root/Assets/Js/Templates',
	'root/Base/Js/Vendor/Modernizr'/*,
	'root/Assets/Js/Vendor/cookie'
	*/
], function(
	$,
	mbiImageSize,
	mbiMq,
    Voucher,
	Flickity,
	SmoothScroll
	) {

	'use strict';

var flktyObjects = [];
function initSwiper() {

    flktyObjects = [];
    if($('.swiper').length) {
        $('.swiper').each(function() {
            if($(this).find('.slide').length > 1) {
            	var $container = $(this);
                if($(this).find('.slide').length >= 2) {
                    var $options = {
                        cellSelector: '.slide',
                        pageDots: false,
                        wrapAround: false,
                        autoPlay: false,
                        draggable: true,
                        prevNextButtons: false,
                        lazyLoad: false,
                        cellAlign: 'center',
                        initialIndex: 1
                  }
                    // document.ontouchmove = function(e){
                    //     return true;
                    // };
                    var flktyid = '#'+$(this).attr('id');
                    var flkty = new Flickity(flktyid, $options);
                    flktyObjects[flktyid] = flkty;

                    $container.parent().find('.js_next').click(function(){
                    	flkty.next();
                    });
                   $container.parent().find('.js_prev').click(function(){
                        flkty.previous();
                    });
                }
                $(this).addClass('is-visible');
            }
        });
        setTimeout(function(){
            mbiImageSize.init();
        },100);
    }
}
initSwiper();
if('lap-' in mbiMq.mqArea) {
    initSwiperMobile();
}

    $(document).on('breakpoint', function(event, data) {
        // console.log('lap-' in data.area);
        if('lap-' in data.area) {
            initSwiperMobile();
        } else {

            if($('#swiper_mobile').hasClass('flickity-enabled')) {
                flktyObjects['#swiper_mobile'].destroy();
            }
        }
        // console.log('breakpoint', data.from+' -> '+data.to);

    });

function initSwiperMobile() {

    // var flktyObjects = [];
    if($('.swiper-mobile').length) {
        $('.swiper-mobile').each(function() {
            if($(this).find('.image-wrapper').length > 1) {
                var $container = $(this);
                if($(this).find('.image-wrapper').length >= 2) {
                    var $options = {
                        cellSelector: '.image-wrapper',
                        pageDots: false,
                        wrapAround: true,
                        autoPlay: true,
                        draggable: true,
                        prevNextButtons: false,
                        lazyLoad: false,
                        cellAlign: 'center'
                  }
                    // document.ontouchmove = function(e){
                    //     return true;
                    // };
                    var flktyid = '#'+$(this).attr('id');
                    var flkty = new Flickity(flktyid, $options);
                    flktyObjects[flktyid] = flkty;
                    // console.log(flktyid);
                    $container.parent().find('.js_next').click(function(){
                        flkty.next();
                    });
                   $container.parent().find('.js_prev').click(function(){
                        flkty.previous();
                    });
                }
                $(this).addClass('is-visible');
            }
        });
        setTimeout(function(){
            mbiImageSize.init();
        },100);
    }
}
/***
	INIT Smooth scroll
*/

	var scroll = new SmoothScroll('a[href*="#"]', {
		easing: 'easeOutQuad',
		speed: 1200,
		offset: 180

	});

	$(document).find('[data-anchor]').each(function(index, el) {
        var id = $(this).attr('data-anchor');
		var name = $(this).attr('data-anchorName');
		$(this).attr('id', id);
		$(document).find('.navigation').append('<li><a href="#'+id+'" data-scroll class="js_close-scroll">'+name+'</a></li>');
	});

	$(document).on('click', '.js_close-scroll', function(){
		$('body').removeClass('is-active');
	})

/***
	INIT WOW
*/

	var wow = new WOW().init({
		offset: 70
	});
	mbiImageSize.init();


/***
	INIT WAYPOINTS

*/
initWaypoints();
function initWaypoints() {
var waypoints = [];

    if($('.js_count-number').length) {
        $('.js_count-number').each(function(index, el){
                var sep = '.';
                // console.log($(this));
            waypoints[index] = new Waypoint({
                element: document.getElementById($(this).attr('id')),
                handler: function(direction) {
                    var numAnim = new CountUp(
                        $(this.element).attr('id'),
                        parseFloat($(this.element).attr('data-count'))/2,
                        parseFloat($(this.element).attr('data-count')), 0, 3.5, {
                            separator : sep,
                              decimal : '',
                              prefix : '',
                              suffix : ''
                        });
                    numAnim.start();
                    this.destroy();

                },
                offset: '100%'
            });
        });
    }
    // if($('.js_sticky').length) {
	   //          waypoints['sticky'] = new Waypoint({
    //             element: $('.js_sticky'),
    //             handler: function(direction) {
            		// console.log(direction);
    //         		if(direction == 'down') {
		  //       		$('.js_sticky').addClass('is-sticky');
		  //       	}
    //             },
    //             offset: 50
    //         });
    // }
}
/***
	INIT CLICKHANDLER
*/

	$(document).on('click', '.js_menu', function(){
		$('body').toggleClass('is-active');
		// $(this).toggleClass('is-active');
	});

	$(document).on('click', '.js_scroll-to', function(){
		var target = $('.section-subhero').offset().top;
		$('body, html').animate({
			scrollTop: target
		},500);
	});

	$(window).on('scroll', function(){
		// console.log($(window).scrollTop());
		if($(window).scrollTop() > 30) {
			$('.site').addClass('is_scrolled');
		} else {

			$('.site').removeClass('is_scrolled');
		}
	});


    $('.content p > img').unwrap();


    $( document ).ready(function() {
        SmorderGutscheine("#giftcardWrapper", 677);
    });

});
define("Assets/Js/Footer.js", function(){});

